import { Checkbox } from "@ths/ui";

import type { CheckoutReminderOptionsQuery } from "../generated/graphql";

export type ReminderOptions =
  CheckoutReminderOptionsQuery["checkoutReminderOptions"];
export type CheckInContact = {
  email: string | null;
  phone?: string;
  smsPromptDismissed?: boolean;
  smsConsent?: boolean;
  smsDisclosureVersion?: string;
};

export function ReminderConsentFields({
  options,
  checked,
  disabled,
  embedded = false,
  onCheckedChange,
}: {
  options: ReminderOptions;
  checked: boolean;
  disabled?: boolean;
  embedded?: boolean;
  onCheckedChange: (value: boolean) => void;
}) {
  return (
    <section
      className={
        embedded
          ? "space-y-3 text-on-navy"
          : "space-y-3 rounded-2xl border border-on-navy/10 bg-on-navy/[0.03] p-4 text-on-navy"
      }
      aria-label="Lodging texts"
    >
      <div className="[&>label]:min-h-11 [&>label]:text-on-navy">
        <Checkbox
          checked={checked}
          disabled={disabled}
          onCheckedChange={onCheckedChange}
          label="Text me updates about my reservations and stays"
          className="border-on-navy/50 bg-on-navy/5 focus-visible:ring-on-navy data-[state=checked]:border-on-navy/70"
        />
      </div>
      <p className="text-[11px] leading-relaxed text-on-navy/60">
        {options.disclosure}{" "}
        <a
          className="rounded-sm text-on-navy/70 underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-on-navy"
          href={options.termsUrl}
          target="_blank"
          rel="noreferrer"
        >
          Terms
        </a>
        {" · "}
        <a
          className="rounded-sm text-on-navy/70 underline underline-offset-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-on-navy"
          href={options.privacyUrl}
          target="_blank"
          rel="noreferrer"
        >
          Privacy
        </a>
      </p>
    </section>
  );
}
